import Dropzone from 'react-dropzone'
import styles from './UploadImage.css'
import { connect } from 'react-redux'
import {Modal} from 'react-bootstrap'
import * as apiUploadImage from 'api/uploadImage'
import {error} from 'actions/notifications'
import FormData from 'form-data'

const ConfirmDeleteModal = ({onCancel, onDelete, show}) => {
  return (
    <Modal onHide={() => {}}
      show={show}
      dialogClassName={`modal-dialog ${styles['confirm-delete-dialog']}`}
    >
      <Modal.Header bsClass={`modal-header ${styles['confirm-delete-header']}`}>
        <Modal.Title>
          Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure to delete this image?
      </Modal.Body>
      <Modal.Footer>
        <span className='pull-right'>
          <button className='btn btn-default' onClick={onCancel}>Cancel</button>
          <button className='btn btn-danger' onClick={onDelete}>Delete</button>
        </span>
      </Modal.Footer>
    </Modal>
  )
}

const UploadValidationModal = ({onHide, showUploadValidationModal, textModal}) => {
  return (
    <Modal
      onHide={onHide}
      show={showUploadValidationModal}
      dialogClassName={`${styles.dialog} modal-dialog margin-top-120`}>
      <Modal.Header>
        <Modal.Title className={styles['title-modal']}>
          Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {textModal}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            className='btn btn-default'
            onClick={onHide}>
            OK
          </button>
        </div>
      </Modal.Footer>
    </Modal>)
}

class UploadImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showUploadValidationModal: false,
      showConfirmDeleteModal: false,
      textModal: '',
      loading: false
    }
  }
  render () {
    let {name, className, input: {value}, defaultImage, placeholder, imageContainerClassName, backgroundColor} = this.props
    const {loading} = this.state
    const actionEditClassName = (value) ? styles['edit-button'] : styles['edit-button-full']
    return (
      <div className={`mk-brand-img-box ${className}`}>
        <div className={`image-preview ${styles['image-container']}`}>
          {!loading && !value && <div style={defaultImage ? {background: `url(${defaultImage})`} : backgroundColor ? {background: backgroundColor} : {background: '#ddd'}} id='img-public-profile' className={`${styles['default-image-container']} ${imageContainerClassName}`}>
            {placeholder}
          </div>}
          {!loading && value && <img src={value} id='img-public-profile' />}
          {loading && <img src='http://dev.mokapos.com/assets/item-image-loading.gif' id='img-public-profile' />}
        </div>
        <div className='img-action-bar trans-1'>
          <div className={`action ${styles.action}`}>
            <Dropzone
              name={name}
              className={actionEditClassName}
              onDrop={this._onDrop}
              multiple={false}>
              Edit
            </Dropzone>
            {!!value && <div className={styles['delete-button']}>
              <span onClick={this._onClickDelete}>
                Delete
              </span>
            </div>}
          </div>
        </div>
        <UploadValidationModal
          showUploadValidationModal={this.state.showUploadValidationModal}
          onHide={this._onHideValidationModal}
          textModal={this.state.textModal}
        />
        {this.props.confirmOnDelete && <ConfirmDeleteModal
          show={this.state.showConfirmDeleteModal}
          onDelete={() => { this._onDelete(); this.setState({showConfirmDeleteModal: false}) }}
          onCancel={() => { this.setState({showConfirmDeleteModal: false}) }}
        />}
      </div>
    )
  }

  _onDrop = (acceptedFiles) => {
    const {input: {onChange}, meta: {dispatch}} = this.props
    let type = acceptedFiles[0].type
    if (acceptedFiles[0].size >= 256000) {
      // show validation modal
      this.setState({
        showUploadValidationModal: true,
        textModal: 'Error: Image file is too big, please upload less than 250 KB'
      })
    } else if (type !== 'image/jpg' && type !== 'image/jpeg' && type !== 'image/png' && type !== 'image/gif') {
      this.setState({
        showUploadValidationModal: true,
        textModal: 'Error: Please upload valid image'
      })
    } else {
      this.uploadImage(acceptedFiles[0]).then((url) => {
        onChange(url)
        this.setState({
          loading: false
        })
      }).catch((reject) => {
        dispatch(error('Upload image failed'))
      })
    }
  }

  uploadImage = async (file) => {
    const {beforeUpload, afterUpload} = this.props
    if (beforeUpload) {
      beforeUpload()
    }
    this.setState({loading: true})
    let resUploadImage = await apiUploadImage.getImage({filename: file.name})
    const {data} = resUploadImage
    let formData = new FormData()
    formData.append('key', data.key)
    formData.append('acl', data.acl)
    formData.append('AWSAccessKeyId', data.aws_access_key_id)
    formData.append('success_action_status', data.success_action_status)
    formData.append('Content-Type', data.content_type)
    formData.append('Cache-Control', data.cache_control)
    formData.append('policy', data.policy)
    formData.append('signature', data.signature)
    formData.append('file', file)
    try {
      await axios.post(data.url, formData, {})
      return Promise.resolve(data.fullUrl)
    } catch (error) {
      return Promise.reject(false)
    } finally {
      if (afterUpload) {
        afterUpload()
      }
    }
  }

  _onClickDelete = () => {
    if (this.props.confirmOnDelete) {
      this.setState({
        showConfirmDeleteModal: true
      })
    } else {
      this._onDelete()
    }
  }

  _onDelete = () => {
    const {input: {onChange}} = this.props
    onChange('')
  }

  _onHideValidationModal = () => {
    this.setState({
      showUploadValidationModal: false,
      textModal: ''
    })
  }
}

function mapStateToProps (state) {
  let {deleted} = state.uploadImage.uploadImage
  return {deleted}
}

UploadImage.propTypes = {
  name: React.PropTypes.string,
  files: React.PropTypes.object,
  onDrop: React.PropTypes.func,
  onDelete: React.PropTypes.func,
  beforeUpload: React.PropTypes.func,
  afterUpload: React.PropTypes.func,
  confirmOnDelete: React.PropTypes.bool
}
export default connect(mapStateToProps)(UploadImage)



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/UploadImage/UploadImage.js